module.exports = __webpack_public_path__ + "img/1.8ffc44e9.png";